import { generateCollectionId } from '@wix/wix-data-client-common-standalone'
import { generateCollectionName } from './generateCollectionName'
import type { Schema } from '@wix/wix-data-schema-types'

type Params = {
  allCollections: Schema[]
  baseName: string
}

export const generateCollectionIdAndName = ({
  allCollections,
  baseName,
}: Params) => {
  const collectionName = generateCollectionName({
    baseName,
    collections: allCollections,
  })

  const collectionId = generateCollectionId(collectionName, allCollections)

  return { collectionName, collectionId }
}
